/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Final_Tie_HintInputs */



/**
* | output |
* | --- |
* | "Some players are tied in the standings: order them with the arrows. The first five are seated, top seed first." |
*
* @param {League_Final_Tie_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_final_tie_hint = /** @type {((inputs?: League_Final_Tie_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Final_Tie_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Des joueurs sont à égalité au classement : ordonnez-les avec les flèches. Les cinq premiers sont placés, tête de série #1 en premier.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Hay jugadores empatados en la clasificación: ordénalos con las flechas. Se sientan los cinco primeros, la primera cabeza de serie arriba.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Há jogadores empatados na classificação: ordene-os com as setas. Os cinco primeiros são sentados, a primeira cabeça de chave no topo.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Alcuni giocatori sono a pari merito in classifica: ordinali con le frecce. I primi cinque vengono disposti, la prima testa di serie in alto.")
	return /** @type {LocalizedString} */ ("Some players are tied in the standings: order them with the arrows. The first five are seated, top seed first.")
});